export default "__VITE_ASSET__C44GFE1i__"